/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import { Box, Button, Grid, MenuItem, Select, TextField, Typography } from "@mui/material";
import OriginImage from "../../assets/QuoteIcons/Origin.png";
import DestinationImage from "../../assets/QuoteIcons/Destination.png";
import BoxInfromationImage from "../../assets/QuoteIcons/BoxInfromation.png";
import { useSelector } from "react-redux";
import { getCountries, getItemCategories, getShippingQuotes } from "../../pages/Shipping/Integration/APIService";
import { useFormik } from "formik";
import countryFlags from "../../CountryFlags.json";
import { getWareHouses, getWarehousesCloud } from "../../helper/functions";

function GetShippingQuote({ setGetShippingQuotes, setShowQuote, finalMarkups, setFormValues }) {
  const userData = useSelector((state) => state.auth.value);
  const [categories, setCategories] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [allCountries, setAllCountries] = useState([]);

  const handleChange = (e) => {
    formik.setFieldValue(e.target.name, e.target.value);
  };
  const getData = async () => {
    // console.log(userData.easyShipApikey,"userData.easyShipApikey");

    const category = await getItemCategories();
    const warehouses = await getWarehousesCloud({});
    console.log(warehouses, "warehouseswarehouses");

    console.log(category, "categories");
    setCategories(category?.item_categories?.map((item) => item.name));
    setAllCountries(countryFlags?.map((coun) => ({ name: coun?.name, code: coun?.code })));
    setWarehouses(warehouses?.map((hou) => ({
      id:hou?.id, warehouseName: hou?.warehouseName, state: hou?.state, countryCode: hou?.countryCode, zipCode: hou?.zipCode, city
        : hou?.city
    })))
  }
  useEffect(() => {
    getData();
  }, [userData])

  const formik = useFormik({
    initialValues: {
      selectedWarehouse:"",
      originCountry: "",
      originState: "",
      originZip: "",
      originCity: "",
      destinationCountry: "",
      destinationState: "",
      destinationZip: "",
      destinationCity: "",
      length: "",
      width: "",
      height: "",
      weight: "",
      category: "",
      declaredValue: 0
    },
    onSubmit: async (values) => {
      console.log(values);
      const finalPayload = {
        origin_address: {
          line_1: values?.originCity,
          line_2: null,
          state: values?.originState,
          city: values?.originCity,
          postal_code: values?.originZip,
          country_alpha2: values?.originCountry
        },
        destination_address: {
          line_1: values?.destinationCity,
          line_2: null,
          state: values?.destinationState,
          city: values?.destinationCity,
          postal_code: values?.destinationZip,
          country_alpha2: values?.destinationCountry
        },
        incoterms: "DDU",
        insurance: {
          is_insured: false
        },
        courier_settings: {
          show_courier_logo_url: true,
          apply_shipping_rules: true
        },
        shipping_settings: {
          units: {
            weight: "lb",
            dimensions: "in"
          }
        },
        parcels: [
          {
            items: [
              {
                origin_country_alpha2: values?.originCountry,
                quantity: 1,
                "dimensions": {
                  "length": +values?.length,
                  "width": +values?.width,
                  "height": +values?.height
                },
                "declared_currency": "USD",
                "description": "",
                "category": values?.category,
                // "hs_code": ,
                "contains_battery_pi966": null,
                "contains_battery_pi967": null,
                "contains_liquids": null,
                "declared_customs_value": +values?.declaredValue,
                "actual_weight": +values?.weight
              }
            ],
            "total_actual_weight": +values?.weight
          }
        ]
      }
      console.log(finalPayload, "finalPayload");

      const shippingQuotes = await getShippingQuotes(finalPayload);
      console.log(shippingQuotes?.rates, "shippingQuotes?.rates");
      console.log(finalMarkups, "finalMarkups");
      setFormValues(values);
      setGetShippingQuotes(shippingQuotes?.rates?.map((service) => service?.courier_service?.id in finalMarkups ? { ...service, markup: finalMarkups[service?.courier_service?.id] } : null)?.filter(val => val));
      setShowQuote(true);
    },
  });

  return (
    <Box
      sx={{
        marginTop: { xs: "15px", sm: "20px", md: "25px" },
        width: { xs: "100%", sm: "95%", md: "90%", lg: "80%" },
        padding: { xs: "0 10px", sm: "0 15px", md: "0" },
      }}
    >
      {/* Origin Section */}
      <Box
        sx={{
          border: "1px solid #E5E5E8",
          borderRadius: { xs: "12px", sm: "16px", md: "20px" },
          marginBottom: { xs: "15px", sm: "20px", md: "25px" },
          padding: { xs: "15px 0", sm: "18px 0", md: "20px 0" },
        }}
      >
        <Typography
          sx={{
            padding: { xs: "0 15px", sm: "0 20px", md: "0 30px" },
            fontWeight: "700",
            fontSize: { xs: "14px", sm: "15px" },
            color: "#1C2630",
            marginBottom: { xs: "15px", sm: "18px", md: "20px" },
            borderBottom: "1px solid #E5E5E8",
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src={OriginImage}
            alt="Origin Icon"
            style={{
              width: "20px",
              height: "20px",
              marginRight: "10px",
            }}
          />{" "}
          Origin
        </Typography>
        <Grid
          container
          spacing={2}
          sx={{
            padding: { xs: "0 15px", sm: "0 20px", md: "0 30px" },
          }}
        >
          <Grid item xs={12} sm={6} md={4}>
            <Typography
              sx={{
                fontSize: { xs: "13px", sm: "14px" },
                fontWeight: "600",
                lineHeight: "16.8px",
                textAlign: "left",
                marginBottom: { xs: "8px", sm: "10px" },
              }}
            >
              Forwarder
            </Typography>
            <Select
              value={formik.values.selectedWarehouse || ""}
              displayEmpty
              fullWidth
              name="originCountry"
              sx={{ height: { xs: "40px", sm: "35px" } }}
              onChange={(e) => {
                console.log(e.target.value, "ffff");
                const selected = warehouses?.find(hou=>hou?.id==e.target.value);
                formik.setValues({
                  selectedWarehouse:e.target.value,
                  originCountry:selected?.countryCode,
                  originState:selected?.state,
                  originZip:selected?.zipCode,
                  originCity:selected?.city                  
                })
              }}
            >
              <MenuItem value="" disabled>
                Select Forwarder
              </MenuItem>
              {warehouses &&
                warehouses?.length > 0 &&
                warehouses.map((warehouse, index) => (
                  <MenuItem key={index} value={warehouse?.id}>
                    {`${warehouse?.warehouseName} - ${warehouse?.state},${warehouse?.countryCode}`}
                  </MenuItem>
                ))}
            </Select>
          </Grid>
          <Grid item xs={6} sm={4}>
            <Typography
              sx={{
                fontSize: { xs: "13px", sm: "14px" },
                fontWeight: "600",
                lineHeight: "16.8px",
                textAlign: "left",
                marginBottom: { xs: "8px", sm: "10px" },
              }}
            >
              City
            </Typography>
            <TextField
              name="originCity"
              value={formik.values.originCity}
              size="small"
              onChange={handleChange}
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <Typography
              sx={{
                fontSize: { xs: "13px", sm: "14px" },
                fontWeight: "600",
                lineHeight: "16.8px",
                textAlign: "left",
                marginBottom: { xs: "8px", sm: "10px" },
              }}
            >
              State
            </Typography>
            <TextField
              name="originState"
              size="small"
              value={formik.values.originState}
              onChange={handleChange}
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography
              sx={{
                fontSize: { xs: "13px", sm: "14px" },
                fontWeight: "600",
                lineHeight: "16.8px",
                textAlign: "left",
                marginBottom: { xs: "8px", sm: "10px" },
              }}
            >
              Zip Code
            </Typography>
            <TextField
              name="originZip"
              value={formik.values.originZip}
              onChange={handleChange}
              size="small"
              fullWidth
              disabled
            />
          </Grid>
        </Grid>
      </Box>

      {/* Destination Section */}
      <Box
        sx={{
          border: "1px solid #E5E5E8",
          borderRadius: { xs: "12px", sm: "16px", md: "20px" },
          marginBottom: { xs: "15px", sm: "20px", md: "25px" },
          padding: { xs: "15px 0", sm: "18px 0", md: "20px 0" },
        }}
      >
        <Typography
          sx={{
            padding: { xs: "0 15px", sm: "0 20px", md: "0 30px" },
            fontSize: { xs: "14px", sm: "15px" },
            fontWeight: "600",
            color: "#1C2630",
            marginBottom: { xs: "15px", sm: "18px", md: "20px" },
            borderBottom: "1px solid #E5E5E8",
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src={DestinationImage}
            alt="image"
            style={{
              width: "20px",
              height: "20px",
              marginRight: "10px",
            }}
          />
          Destination
        </Typography>
        <Grid
          container
          spacing={2}
          sx={{
            padding: { xs: "0 15px", sm: "0 20px", md: "0 30px" },
          }}
        >
          <Grid item xs={12} sm={6} md={4}>
            <Typography
              sx={{
                fontSize: { xs: "13px", sm: "14px" },
                fontWeight: "600",
                lineHeight: "16.8px",
                textAlign: "left",
                marginBottom: { xs: "8px", sm: "10px" },
              }}
            >
              Country
            </Typography>

            <Select
              value={formik.values.destinationCountry || ""}
              displayEmpty
              fullWidth
              name="destinationCountry"
              sx={{ height: { xs: "40px", sm: "35px" } }}
              onChange={handleChange}
            >
              <MenuItem value="" disabled>
                Select Country
              </MenuItem>
              {allCountries &&
                allCountries?.length > 0 &&
                allCountries.map((coun) => (
                  <MenuItem key={coun?.code} value={coun?.code}>
                    {coun?.name}
                  </MenuItem>
                ))}
            </Select>
          </Grid>
          <Grid item xs={6} sm={4}>
            <Typography
              sx={{
                fontSize: { xs: "13px", sm: "14px" },
                fontWeight: "600",
                lineHeight: "16.8px",
                textAlign: "left",
                marginBottom: { xs: "8px", sm: "10px" },
              }}
            >
              City
            </Typography>
            <TextField
              name="destinationCity"
              value={formik.values.destinationCity}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <Typography
              sx={{
                fontSize: { xs: "13px", sm: "14px" },
                fontWeight: "600",
                lineHeight: "16.8px",
                textAlign: "left",
                marginBottom: { xs: "8px", sm: "10px" },
              }}
            >
              State
            </Typography>
            <TextField
              name="destinationState"
              value={formik.values.destinationState}
              size="small"
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography
              sx={{
                fontSize: { xs: "13px", sm: "14px" },
                fontWeight: "600",
                lineHeight: "16.8px",
                textAlign: "left",
                marginBottom: { xs: "8px", sm: "10px" },
              }}
            >
              Zip Code
            </Typography>
            <TextField
              name="destinationZip"
              value={formik.values.destinationZip}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
        </Grid>
      </Box>

      {/* Box Information Section */}
      <Box
        sx={{
          border: "1px solid #E5E5E8",
          borderRadius: { xs: "12px", sm: "16px", md: "20px" },
          marginBottom: { xs: "15px", sm: "20px", md: "25px" },
          padding: { xs: "15px 0", sm: "18px 0", md: "20px 0" },
        }}
      >
        <Typography
          sx={{
            padding: { xs: "0 15px", sm: "0 20px", md: "0 30px" },
            fontWeight: "600",
            fontSize: { xs: "14px", sm: "15px" },
            color: "#1C2630",
            borderBottom: "1px solid #E5E5E8",
            marginBottom: { xs: "15px", sm: "18px", md: "20px" },
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src={BoxInfromationImage}
            alt="image"
            style={{
              width: "20px",
              height: "20px",
              marginRight: "10px",
            }}
          />
          Box Information
        </Typography>
        <Grid
          container
          spacing={2}
          sx={{
            padding: { xs: "0 15px", sm: "0 20px", md: "0 30px" },
          }}
        >
          <Grid item xs={12} sm={6} md={4}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
                marginLeft: "2px",
                gap: "10px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "600",
                  lineHeight: "16.8px",
                  textAlign: "left",
                  marginBottom: "10px",
                }}
              >
                L
              </Typography>
              <TextField
                name="length"
                value={formik.values.length}
                onChange={handleChange}
                fullWidth
                size="small"
                type="number"
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
                marginLeft: "2px",
                gap: "10px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "600",
                  lineHeight: "16.8px",
                  textAlign: "left",
                  marginBottom: "10px",
                }}
              >
                W
              </Typography>
              <TextField
                name="width"
                value={formik.values.width}
                onChange={handleChange}
                size="small"
                fullWidth
                type="number"
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
                marginLeft: "2px",
                gap: "10px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "600",
                  lineHeight: "16.8px",
                  textAlign: "left",
                  marginBottom: "10px",
                }}
              >
                H
              </Typography>
              <TextField
                label=""
                name="height"
                value={formik.values.height}
                onChange={handleChange}
                fullWidth
                size="small"
                type="number"
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "16.8px",
                textAlign: "left",
                marginBottom: "10px",
              }}
            >
              Weight (lb)
            </Typography>
            <TextField
              name="weight"
              value={formik.values.weight}
              onChange={handleChange}
              fullWidth
              size="small"
              type="number"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              sx={{
                fontSize: { xs: "13px", sm: "14px" },
                fontWeight: "600",
                lineHeight: "16.8px",
                textAlign: "left",
                marginBottom: { xs: "8px", sm: "10px" },
              }}
            >
              Category
            </Typography>
            <Select
              value={formik.values.category || ""}
              displayEmpty
              fullWidth
              name="category"
              sx={{ height: { xs: "40px", sm: "35px" } }}
              onChange={handleChange}
            >
              <MenuItem value="" disabled>
                Select Category
              </MenuItem>
              {categories &&
                categories?.length > 0 &&
                categories.map((cat) => (
                  <MenuItem key={cat} value={cat}>
                    {cat}
                  </MenuItem>
                ))}
            </Select>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              sx={{
                fontSize: { xs: "13px", sm: "14px" },
                fontWeight: "600",
                lineHeight: "16.8px",
                textAlign: "left",
                marginBottom: { xs: "8px", sm: "10px" },
              }}
            >
              Declared Value
            </Typography>
            <TextField
              name="declaredValue"
              value={formik.values.declaredValue}
              onChange={handleChange}
              fullWidth
              size="small"
              type="number"
            />
          </Grid>
        </Grid>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: { xs: "center", sm: "flex-end" },
          marginTop: { xs: "15px", sm: "20px" },
          padding: { xs: "0 15px", sm: "0" },
        }}
      >
        <Button
          sx={{
            textAlign: "center",
            width: { xs: "100%", sm: "auto" },
            minWidth: { xs: "100%", sm: "150px" },
            padding: { xs: "10px 20px", sm: "8px 16px" },
          }}
          variant="contained"
          type="submit"
          onClick={formik.handleSubmit}
        >
          Calculate Quote
        </Button>
      </Box>
    </Box>
  );
}

export default GetShippingQuote;
